// extracted by mini-css-extract-plugin
export default {"container":"GT-z","title":"HT-z","link":"IT-z"};